"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _wrapper;

  return {
    wrapper: (_wrapper = {
      display: "grid",
      gridGap: theme.spacing(2),
      gridTemplateRows: "auto",
      gridTemplateColumns: "1fr"
    }, _defineProperty(_wrapper, theme.breakpoints.up("sm"), {
      gridTemplateColumns: "repeat(2, 1fr)"
    }), _defineProperty(_wrapper, theme.breakpoints.up("md"), {
      gridTemplateColumns: "repeat(3, 1fr)"
    }), _wrapper)
  };
});
var _default = styles;
exports.default = _default;